import { render, staticRenderFns } from "./SetCourse.vue?vue&type=template&id=4eeb21a8&scoped=true&"
import script from "./SetCourse.vue?vue&type=script&lang=js&"
export * from "./SetCourse.vue?vue&type=script&lang=js&"
import style0 from "./SetCourse.vue?vue&type=style&index=0&id=4eeb21a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeb21a8",
  null
  
)

export default component.exports